import { IPhone } from "@interfaces";
import { memo } from "react";
import * as Yup from "yup";
import { useYup } from "@validations";
import { Input, Form, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { SharedButton, StyledAuth } from "@components";
import { setLoading, setRefresh, updatePhone, updateTemp, useAppDispatch } from "@redux";

import { useNotify, getApiErrorMessage } from "@utils";
import { PATH_OTP } from "@configs";
import { useHistory } from "react-router";
import { clinicApi } from "@api";

const initValue: IPhone = {
  phone_number: "",
};

export const PhoneLoginForm = memo(() => {
  const { YupPhone } = useYup();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { success, error } = useNotify();
  const history = useHistory();
  // form and validation
  const phoneSchema = Yup.object().shape(YupPhone);
  const [phoneForm] = Form.useForm();

  const onFinish = async (values: IPhone) => {
    try {
      dispatch(setLoading(true));
      await console.log(values);
      const res = await clinicApi.requestOtp(values);
      if (res.data?.token) {
        await history.push(PATH_OTP);
        await dispatch(updateTemp(res?.data?.token));
        await dispatch(updatePhone(values.phone_number || ""));
      }
      // unwrapResult(res);
      // success(t("message.login.success"));
    } catch (err: any) {
      error(getApiErrorMessage(err, t("message.fetch.fail")));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const yupSync = {
    async validator({ field }: any, value: any) {
      await phoneSchema.validateSyncAt(field, { [field]: value });
    },
  };
  return (
    <StyledAuth>
      <Form
        form={phoneForm}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        layout="vertical"
      >
        <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={24} md={24} sm={24}>
            <Form.Item label={t("page.phone_number")} name="phone_number" rules={[yupSync]}>
              <Input type="number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={8} md={8} sm={8} />
          <Col lg={8} md={8} sm={8}>
            <SharedButton type="primary" htmlType="submit" size="middle">
              {t("page.confirm")}
            </SharedButton>
          </Col>
          <Col lg={8} md={8} sm={8} />
        </Row>
      </Form>
    </StyledAuth>
  );
});
